export default __webpack_public_path__ + "a1c303d495a6a158bd6cc3775bdfc26d.png";